import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.corona-cert-validation';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleCoronaCertValidationEffects {

    CoronaCertValidation$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CORONA_CERT_VALIDATION),
        mergeMap((x: ac.PostCoronaCertValidationAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postCoronaCertValidation(x.coronaCertValidationRequest).pipe(
                map((result: any) => {
                    return new ac.PostCoronaCertValidationErfolgreichAction(result, x.coronaCertValidationRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostCoronaCertValidationFehlerAction(error, x.coronaCertValidationRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleService);
        }
        return this.service;
    }
}
